import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	CreateAssessmentQuestionFeedbackInput,
	GetAssessmentQuestionConfigByIdAPIResponse,
	GetFeedbackQuestionFeedbackAPIResponse,
} from 'types';

const baseUrl = `${API_ENDPOINT}/assessment-question-feedback`;

export const createAssessmentQuestionFeedback = async (
	assessmentQuestionFeedbackInfo: CreateAssessmentQuestionFeedbackInput,
): Promise<GetFeedbackQuestionFeedbackAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}`, assessmentQuestionFeedbackInfo);
	return response.data;
};

export const getAssessmentQuestionFeedbackByMeetingAndQuestionId = async (
	questionId: string,
	token: string,
	meetingId: string,
): Promise<GetAssessmentQuestionConfigByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-by/${meetingId}`, {
		params: { questionId, token },
	});
	return response.data;
};
